import { render, staticRenderFns } from "./TopTaskIcon.vue?vue&type=template&id=eb21560c&scoped=true"
import script from "./TopTaskIcon.vue?vue&type=script&lang=ts"
export * from "./TopTaskIcon.vue?vue&type=script&lang=ts"
import style0 from "./TopTaskIcon.vue?vue&type=style&index=0&id=eb21560c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb21560c",
  null
  
)

export default component.exports